import React, { useState, useContext, useEffect, useRef } from "react";
import "./InfoLateralEntradas.scss";
import "bootstrap/dist/js/bootstrap.bundle.min";
import axios from "axios";
import { AdicionandoDados } from "../../context/AdicionandoDados";
import { Modal } from "bootstrap"; // Importa o Modal do Bootstrap
import Select from "react-select";

import { ToastContainer, toast, Bounce } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import { Accordion } from "react-bootstrap";

interface Anexo {
  isPosibleEdit: boolean | undefined;
  name: string;
  path?: string;
  file?: File;
}

interface Entrada {
  anexos(anexos: any): unknown;
  id: number;
  dataentrada: string;
  fonteentrada: string;
  valorentrada: string;
  tipoentrada?: string;
  descricaoentrada?: string;
  anexo?: Anexo[]; // Atualizado para acomodar anexos existentes e novos
}

interface Time {
  nometime: string;
  projetos?: Projeto[];
}

interface Projeto {
  nomeprojeto: string;
}

const InfoLateralEntradasPt2 = () => {
  const { estaAdicionandoDados, setEstaAdicionandoDados } =
    useContext(AdicionandoDados);

  const [ILEpt2Form01, setILEpt2Form01] = useState<string>("");
  const [ILEpt2Form02, setILEpt2Form02] = useState<string>("");
  const [ILEpt2Form03, setILEpt2Form03] = useState<string>("");
  const [ILEpt2Form04, setILEpt2Form04] = useState<string>("");
  const [ILEpt2Form05, setILEpt2Form05] = useState<string>("");
  const [ILEpt2Form06, setILEpt2Form06] = useState<string>("");

  const [entradas, setEntradas] = useState<Entrada[]>([]);
  const [dataPesquisaGeral, setDataPesquisaGeral] = useState("");
  const [entradaSelecionada, setEntradaSelecionada] = useState<Entrada | null>(
    null
  );
  const [dataAnexos, setDataAnexos] = useState<Anexo[]>([]);

  const modalRef = useRef<HTMLDivElement>(null);
  const bootstrapModalRef = useRef<Modal | null>(null);
  const [listaAnexos, setListaAnexos] = useState<any[]>([]);

  const [dataEmpresa, setDataEmpresa] = useState(
    localStorage.getItem("dataEmpresa")
  );

  const toastSave = () => {
    toast.success("Entrada Salva com Sucesso!", {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    });
  };

  useEffect(() => {
    // Inicializa o modal do Bootstrap
    if (modalRef.current) {
      bootstrapModalRef.current = new Modal(modalRef.current, {
        backdrop: "static",
      });
    }

    renderTabela();
  }, []); // Adicione um array de dependências vazio

  useEffect(() => {
    if (entradaSelecionada) {
      getentradasbyid(entradaSelecionada.id);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entradaSelecionada]);

  const getAllComponentByData = async (data: string) => {
    try {
      const responseAll = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getAllComponentsByData/${data}`
      );
      setEntradas(responseAll.data);
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Erro ao buscar os dados.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  const renderTabela = async () => {
    try {
      const responseAll = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getallentradas`
      );
      setEntradas(responseAll.data);
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Erro ao buscar os dados.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };


  const saveDataById = async (id: number) => {
    try {
      // Atualiza a entrada
      const response = await axios.put(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/puteditentradas/${id}`,
        {
          fonteentrada: fontesaida,
          dataentrada: ILEpt2Form03,
          projetos: projetosByEmpresaSelecionada,
          valorentrada: ILEpt2Form04,
          descricaoentrada: ILEpt2Form05,
          projeto: ILEpt2Form06,
        }
      );

      // Verifica se a entrada foi atualizada com sucesso antes de salvar os anexos
      if (response.status === 200) {
        // Chama a função para salvar os anexos relacionados à entrada
        if (entradaSelecionada?.id) {
          await saveAnexoEntrada(entradaSelecionada.id);
        }

        // Atualiza a tabela e fecha o modal
        renderTabela();

        bootstrapModalRef.current?.hide();
      } else {
        toast.error(
          "Erro ao atualizar a entrada. Por favor, tente novamente.",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          }
        );
      }
      toastSave();
    } catch (error: any) {
      toast.error(
        error.response?.data?.message ||
          "Erro ao salvar os dados. Por favor, tente novamente.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  const saveData = async () => {
    const dataFormatada = new Date(ILEpt2Form03).toISOString().slice(0, 10);
    try {
      const response = await axios.post(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/postallentradas`,
        {
          empresaselecionada: empresaSelecionada,
          centrocusto: centroCustoByEmpresaSelecionada,
          projetos: projetosByEmpresaSelecionada,
          fonteentrada: fontesaida,
          dataentrada: dataFormatada,
          valorentrada: ILEpt2Form04,
          descricaoentrada: ILEpt2Form05,
        }
      );

      if (response.data.id) {
        // Verifica se o ID existe antes de prosseguir
        await saveAnexoEntrada(response.data.id);

        dataAnexos.map((anexo) => {
          anexo.isPosibleEdit = false;
        })
      } else {
        toast.error(
          "ID não encontrado na resposta. Não é possível salvar anexo.",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          }
        );
      }

      if(projetosByEmpresaSelecionada.length > 0){
        await saveValorProjeto();
      }
      

      renderTabela();
      setEntradaSelecionada(null);
      setILEpt2Form01("");
      setILEpt2Form02("");
      setILEpt2Form03("");
      setILEpt2Form04("");
      setILEpt2Form05("");
      setILEpt2Form06("");
      setEmpresaSelecionada("");
      setCentroCustoByEmpresaSelecionada("");
      setProjetosByEmpresaSelecionada([]);
      setFontesaida("");
      setListaAnexos([]);

      toastSave();
    } catch (error: any) {
      toast.error(
        error.response?.data?.message ||
          "Erro ao salvar os dados. Por favor, tente novamente.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files) {
      // Convertendo FileList para Array e adicionando ao estado
      const arrayFiles = Array.from(files).map((file) => ({
        name: file.name,
        file,
        isPosibleEdit: true,
      }));
      setListaAnexos((prevAnexos) => [...prevAnexos, ...Array.from(files)]);
      setDataAnexos((prevDataAnexos) => [...prevDataAnexos, ...arrayFiles]);
    }
  };

  const getentradasbyid = async (id: number) => {
    try {
      const response = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getentradasbyid/${id}`
      );
      setEmpresaSelecionada(response.data.empresaselecionada);
      setTipoDespesaSelecionada(response.data.tipodespesa);
      setCentroCustoByEmpresaSelecionada(response.data.centrocusto);
      setProjetosByEmpresaSelecionada(response.data.projetos);
      setBeneficiarioSelecionado(response.data.beneficiario);
      setFontesaida(response.data.fontesaida);
      setILEpt2Form02(response.data.fonteentrada);
      setILEpt2Form03(response.data.dataentrada.slice(0, 10)); // Assumindo que a data está em formato ISO
      setILEpt2Form04(response.data.valorentrada);
      setILEpt2Form05(response.data.descricaoentrada || "");
      setILEpt2Form06(response.data.projeto);

      const anexos = response.data.anexo || [];

      const formattedAnexos = anexos.map((path: string) => {
        return {
          name: path.split("/").pop(), // Extrai o nome do arquivo do caminho
          path: path,
        };
      });
      setDataAnexos(formattedAnexos);
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || "Erro ao buscar os dados por ID.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  const deleteData = async (id: number) => {
    try {
      await axios.delete(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/deleteentrada/${id}`
      );
      // Atualiza a tabela após deletar
      renderTabela();
      toast.success("Entrada deletada com sucesso!", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } catch (error: any) {
      toast.error(
        error.response?.data?.message ||
          "Erro ao deletar os dados. Por favor, tente novamente.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  const handleEditarClick = (entrada: any) => {
    setEntradaSelecionada(entrada);
    setMostrarAnexos(false); // Reseta o estado de exibição de anexos
    bootstrapModalRef.current?.show(); // Exibe o modal sem anexos inicialmente
  };

  const handleAdicionarClick = () => {
    setEntradaSelecionada(null);
    setILEpt2Form01("");
    setILEpt2Form02("");
    setILEpt2Form03("");
    setILEpt2Form04("");
    setILEpt2Form05("");
    setDataAnexos([]);
    bootstrapModalRef.current?.show(); // Abre o modal para adicionar
  };

  const deleteDataAnexos = async (anexo: any) => {
    // Exibe uma mensagem de confirmação para o usuário
    const confirmDelete = window.confirm(
      "Tem certeza que deseja excluir este anexo?"
    );

    if (!confirmDelete) {
      return; // Sai da função se o usuário cancelar a exclusão
    }

    try {
      await axios.delete(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/deleteanexosentrada/${anexo.name}`
      );

      toast.success("Anexo deletado com sucesso!", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });

      // Atualiza a lista de anexos após deletar
      setDataAnexos((prevAnexos) =>
        prevAnexos.filter((item) => item.name !== anexo.name)
      );
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Erro ao deletar o anexo.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  const saveAnexoEntrada = async (entradaId: number) => {
    try {
      for (const anexo of dataAnexos) {
        if (anexo.file) {
          const formData = new FormData();
          formData.append("file", anexo.file); // Anexa o arquivo

          const dataAtual = Date.now();
          const encodedFileName = encodeURIComponent(anexo.name); // Codifica o nome do arquivo

          // Inclui o ID da entrada na URL com dados necessários
          const uploadUrl = `https://financeiro.api.protmar.com.br/${dataEmpresa}/uploadfileentradas/${dataAtual}_${encodedFileName}/${entradaId}`;

          // Executa o upload do arquivo
          const response = await axios.post(uploadUrl, formData);

          // Você pode optar por exibir uma notificação de sucesso para cada upload
          toast.success(`Anexo ${anexo.name} enviado com sucesso!`, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });
        }
      }
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        toast.error(
          error.response?.data?.message || "Erro ao fazer upload do arquivo.",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          }
        );
      } else {
        toast.error("Erro desconhecido ao fazer upload do arquivo.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    }
  };

  const downloadFile = (file: string, fileName: string) => {
    const blob = new Blob([file]);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const handleDownload = (file: any, fileName = "download.pdf") => {
    if (file) {
      downloadFile(file, fileName);
    }
  };

  const openImages = async (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    name: string
  ) => {
    event.preventDefault();
    
    try {
      // Faz a requisição para buscar a URL pré-assinada passando o ID do anexo
      const response = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/get-signed-url/${name}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Adiciona o token JWT no cabeçalho
          },
        }
      );
  
      // Abre a URL no navegador
      window.open(response.data.url, "_blank");
    } catch (error: any) {
      console.error("Erro ao buscar a URL pré-assinada:", error.message || error);
      alert("Não foi possível abrir a imagem. Verifique sua conexão ou entre em contato com o suporte.");
    }
  };
  
  const [estaEditandoAnexos, setEstaEditandoAnexos] = useState(false);

  // PARTE DE TIMES /////////////////////////////////////////////////////////////////

  const [nomeTime, setNomeTime] = useState<Time[]>([]);
  const [timeAtual, setTimeAtual] = useState<string>();
  const getTimesList = async () => {
    try {
      const response = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/gettimes`
      );
      const teams = response.data;

      // Para cada time, busque seus projetos
      const teamsWithProjectsPromises = teams.map(async (team: Time) => {
        const projetosResponse = await axios.get(
          `https://financeiro.api.protmar.com.br/${dataEmpresa}/getprojetobynome/${team.nometime}`
        );
        return {
          ...team,
          projetos: projetosResponse.data,
        };
      });

      const teamsWithProjects = await Promise.all(teamsWithProjectsPromises);

      setNomeTime(teamsWithProjects);
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Erro ao buscar times.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  useEffect(() => {
    getTimesList();
  }, []);

  // Função para normalizar strings
  const normalizeString = (str: string) =>
    str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // Remove acentos
      .trim()
      .toLowerCase();

  const projetosMap: { [key: string]: any[] } = {
    "time software": [],
    "time educacional": [],
    "time ocupacional e terceiros": [],
    "time mecanica": [],
    "time area classificada e eletrica": [],
  };

  // Preencher projetosMap com os projetos obtidos
  useEffect(() => {
    nomeTime.forEach((team) => {
      const key = normalizeString(team.nometime);
      projetosMap[key] = team.projetos || [];
    });
  }, [nomeTime]);

  const saveValorProjeto = async () => {
    try {
      const projetoNomeNormalizado = normalizeString(ILEpt2Form06);
      const response = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getprojetobyname/${projetoNomeNormalizado}`
      );

      const valorgastoprojeto = parseFloat(response.data.valorgastoprojeto);
      const valorEntrada = parseFloat(ILEpt2Form04);

      const valorSomado = valorgastoprojeto + valorEntrada;

      await axios.put(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/putprojetobyname/${projetoNomeNormalizado}`,
        {
          valor: valorSomado,
        }
      );

      toast.success("Valor do projeto atualizado com sucesso!", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } catch (error: any) {
      toast.error(
        error.response?.data?.message ||
          "Erro ao atualizar o valor do projeto.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  const [mostrarAnexos, setMostrarAnexos] = useState<boolean>(false); // Adiciona estado para exibir anexos
  const handleExibirAnexosClick = async () => {
    if (!entradaSelecionada) {
      setMostrarAnexos(true);
      return;
    }

    const id = entradaSelecionada.id;

    try {
      if (!entradaSelecionada) {
        setDataAnexos(listaAnexos);
      }

      const response = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getallimages/${id}`
      );

      const listaToAdd = response.data.map((e: any) => ({
        name: e.name,
        path: e.url,
      }));

      // Atualiza o estado com os anexos
      setDataAnexos(listaToAdd);
      setMostrarAnexos(true); // Seta o estado de exibição de anexos como verdadeiro
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Erro ao carregar anexos.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  ///////////////////////////////////////////////////////////////////////

  const [empresasCadastradas, setEmpresasCadastradas] = useState<any[]>([]);
  const [empresaSelecionada, setEmpresaSelecionada] = useState<string>("");
  const [empresaFonteSaida, setEmpresaFonteSaida] = useState("");

  useEffect(() => {
    const fetchEmpresas = async () => {
      try {
        const response = await axios.get(
          `https://financeiro.api.protmar.com.br/${dataEmpresa}/getempresas/`
        );
        setEmpresasCadastradas(response.data);
      } catch (error: any) {
        toast.error(
          error.response?.data?.message ||
            "Erro ao buscar empresas cadastradas.",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          }
        );
      }
    };

    fetchEmpresas();
  }, [dataEmpresa]);

  const [centroCustoByEmpresa, setCentroCustoByEmpresa] = useState<any[]>([]);
  const [centroCustoByEmpresaSelecionada, setCentroCustoByEmpresaSelecionada] =
    useState("");

  const [projetosByEmpresa, setProjetosByEmpresa] = useState<any[]>([]);
  const [projetosByEmpresaSelecionada, setProjetosByEmpresaSelecionada] =
    useState<string[]>([]);

  const getCentroCustoByEmpresa = async () => {
    try {
      const response = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getcentrocustobyidempresa/${empresaSelecionada}`
      );
      setCentroCustoByEmpresa(response.data);
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || "Erro ao buscar centros de custo.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  const getProjetosByEmpresa = async () => {
    try {
      const response = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getprojetosbyidcc/${centroCustoByEmpresaSelecionada}`
      );
      setProjetosByEmpresa(response.data);
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Erro ao buscar projetos.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  useEffect(() => {
    if (empresaSelecionada) {
      // verifica se uma empresa foi realmente selecionada
      getCentroCustoByEmpresa();
    }
  }, [empresaSelecionada]);

  useEffect(() => {
    if (centroCustoByEmpresaSelecionada) {
      // verifica se um centro de custo foi realmente selecionado
      getProjetosByEmpresa();
    }
  }, [centroCustoByEmpresaSelecionada]);

  const [idCentroCustoSelecionado, setIdCentroCustoSelecionado] = useState("");
  const [centroCustosCadastrados, setCentroCustosCadastrados] = useState([]);

  useEffect(() => {
    const fetchCentroCustos = async () => {
      try {
        const response = await axios.get(
          `https://financeiro.api.protmar.com.br/${dataEmpresa}/getcentrocusto/`
        );
        setCentroCustosCadastrados(response.data);
      } catch (error: any) {
        toast.error(
          error.response?.data?.message ||
            "Erro ao buscar centros de custo cadastrados.",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          }
        );
      }
    };

    fetchCentroCustos();
  }, [dataEmpresa]);

  const [visualizarAddProjeto, setVisualizarAddProjeto] = useState(false);
  const [nomeProjeto, setNomeProjeto] = useState("");

  const handleSaveProjeto = async () => {
    try {
      await axios.post(`https://financeiro.api.protmar.com.br/${dataEmpresa}/postprojetos`, {
        nomeprojeto: nomeProjeto,
        idcentrocusto: idCentroCustoSelecionado,
      });

      getProjetosByEmpresa();
      toastSave();
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || "Erro ao cadastrar projeto.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  const options2 = projetosByEmpresa
    .filter((e) => e.nomeprojeto !== undefined && e.nomeprojeto !== null)
    .map((e) => ({
      value: e.nomeprojeto as string,
      label: e.nomeprojeto as string,
    }));

  const [beneficiarioSelecionado, setBeneficiarioSelecionado] = useState("");
  const handleSaveBeneficiario = async () => {
    try {
      await axios.post(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/postbeneficiarios`,
        {
          beneficiario: beneficiarioSelecionado,
        }
      );

      getAllBeneficiarios();
      toastSave();
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || "Erro ao cadastrar beneficiário.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  const [visualizarAddBeneficiario, setVisualizarAddBeneficiario] =
    useState(false);
  const [allBeneficiarios, setAllBeneficiarios] = useState([]);

  const getAllBeneficiarios = async () => {
    try {
      const response = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getbeneficiarios`
      );

      setAllBeneficiarios(response.data);
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || "Erro ao buscar beneficiários.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  useEffect(() => {
    getAllBeneficiarios();
  }, [dataEmpresa]);

  const [visualizarAddFontesaida, setVisualizarAddFontesaida] = useState(false);

  const handleSaveFonteSaida = async () => {
    try {
      await axios.post(`https://financeiro.api.protmar.com.br/${dataEmpresa}/postfontesaida`, {
        fontesaida: visualizarAddFontesaida,
      });

      getAllFonteSaida();
      toastSave();
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || "Erro ao cadastrar fonte de saída.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  const [allFonteSaida, setAllFonteSaida] = useState([]);
  const getAllFonteSaida = async () => {
    try {
      const response = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getfontesaida/`
      );

      setAllFonteSaida(response.data);
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || "Erro ao buscar fontes de saída.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        }
      );
    }
  };

  useEffect(() => {
    getAllFonteSaida();
  }, [dataEmpresa]);

  const [tipoDespesaSelecionada, setTipoDespesaSelecionada] = useState("");
  const [fontesaida, setFontesaida] = useState<string>("");
  const [indivisualAnexo, setIndividualAnexo] = useState<any>([]);

  const renderTabelaAddData = () => {
    return (
      <table className="table">
        <tr>
          <td>
            <label htmlFor="">Empresa</label>
            <select
              className="form-select"
              aria-label="Selecione a Empresa"
              style={{ marginRight: "10px" }}
              value={empresaSelecionada}
              onChange={(e) => {
                const selectedEmpresa = e.target.value;
                setEmpresaSelecionada(selectedEmpresa);

                // Encontra a empresa correspondente e define o tipo de despesa
                const empresa = empresasCadastradas.find(
                  (empresa) => empresa.nomeempresa === selectedEmpresa
                );
                setTipoDespesaSelecionada(empresa?.tipodespesaempresa || "");
              }}
            >
              <option value="">Selecione a Empresa</option>
              {empresasCadastradas.map((empresa) => (
                <option key={empresa.id} value={empresa.nomeempresa}>
                  {empresa.nomeempresa}
                </option>
              ))}
            </select>
          </td>

          <td>
            <label htmlFor="">Centro de Custo</label>
            <select
              className="form-select"
              aria-label="Selecione o Centro de Custo"
              style={{ marginRight: "10px" }}
              value={centroCustoByEmpresaSelecionada}
              onChange={(e) =>
                setCentroCustoByEmpresaSelecionada(e.target.value)
              }
            >
              <option value="">Selecione o Centro de Custo</option>
              {centroCustoByEmpresa.map((e) => (
                <option key={e.id} value={e.nomecentrocusto}>
                  {e.nomecentrocusto}
                </option>
              ))}
            </select>
          </td>
        </tr>

        <tr>
          <td>
            <label htmlFor="">Projetos</label>
            <div style={{ display: "flex" }}>
              <Select
                aria-label="Selecione o Projeto"
                styles={{
                  container: (provided) => ({
                    ...provided,
                    marginRight: "10px",
                  }),
                }}
                isMulti
                id="styleeee"
                options={options2} // Use sempre as opções de projetos cadastrados
                value={projetosByEmpresaSelecionada.map((name) => ({
                  value: name,
                  label: name,
                }))} // Define o valor com base nos projetos selecionados
                placeholder="Selecione o Projeto"
                onChange={(selectedOptions) =>
                  setProjetosByEmpresaSelecionada(
                    selectedOptions
                      ? selectedOptions.map((option) => option.value)
                      : []
                  )
                }
              />

              <a
                onClick={() => {
                  visualizarAddProjeto
                    ? setVisualizarAddProjeto(false)
                    : setVisualizarAddProjeto(true);
                }}
                className="btn btn-primary"
              >
                {visualizarAddProjeto ? "-" : "+"}
              </a>
            </div>

            {visualizarAddProjeto ? (
              <div className="card" style={{ width: "96%" }}>
                <div className="card-body" style={{ width: "100%" }}>
                  <h5 className="card-title">Adicionar Projeto</h5>
                  <label htmlFor="">Nome do Projeto</label>
                  <input
                    onChange={(e: any) => {
                      setNomeProjeto(e.target.value);
                    }}
                    type="text"
                    className="form-control"
                  />

                  <br />

                  <div style={{ display: "flex" }}>
                    <select
                      className="form-select"
                      aria-label="Selecione o Centro de Custo"
                      style={{ marginRight: "10px" }}
                      value={idCentroCustoSelecionado}
                      onChange={(e: any) =>
                        setIdCentroCustoSelecionado(e.target.value)
                      }
                    >
                      <option value="">Selecione o Centro de Custo</option>
                      {centroCustosCadastrados.map((cc: any) => (
                        <option key={cc.id} value={cc.nomecentrocusto}>
                          {cc.nomecentrocusto}
                        </option>
                      ))}
                    </select>

                    <a onClick={handleSaveProjeto} className="btn btn-primary">
                      Salvar
                    </a>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </td>

          <td>
            <label htmlFor="">Fonte Entrada</label>

            <div style={{ display: "flex" }}>
              <select
                className="form-select"
                aria-label="Selecione a Fonte de Entrada"
                style={{ marginRight: "10px" }}
                value={fontesaida}
                onChange={(e: any) => setFontesaida(e.target.value)}
              >
                <option value="">Selecione a Fonte de Entrada</option>
                {allFonteSaida.map((cc: any) => (
                  <option key={cc.id} value={cc.fontesaida}>
                    {cc.fontesaida}
                  </option>
                ))}
              </select>
              <a
                onClick={() => {
                  visualizarAddFontesaida
                    ? setVisualizarAddFontesaida(false)
                    : setVisualizarAddFontesaida(true);
                }}
                className="btn btn-primary"
              >
                {visualizarAddFontesaida ? "-" : "+"}
              </a>
            </div>

            {visualizarAddFontesaida ? (
              <div className="card" style={{ width: "96%" }}>
                <div className="card-body" style={{ width: "100%" }}>
                  <h5 className="card-title">Adicionar Fonte de Entrada</h5>

                  <br />
                  <label htmlFor="">Nome da Fonte de Entrada</label>

                  <div style={{ display: "flex" }}>
                    <input
                      style={{ marginRight: "10px" }}
                      onChange={(e: any) => {
                        setVisualizarAddFontesaida(e.target.value);
                      }}
                      type="text"
                      className="form-control"
                    />

                    <a
                      onClick={handleSaveFonteSaida}
                      className="btn btn-primary"
                    >
                      Salvar
                    </a>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </td>
        </tr>

        <tr>
          <td>
            <div className="mb-3">
              <label className="form-label">Data Entrada</label>
              <input
                value={ILEpt2Form03}
                onChange={(e) => setILEpt2Form03(e.target.value)}
                className="form-control"
                type="date"
              />
            </div>
          </td>
          <td>
            <div className="mb-3">
              <label className="form-label">Valor Entrada</label>
              <input
                value={ILEpt2Form04}
                onChange={(e) => setILEpt2Form04(e.target.value)}
                className="form-control"
                type="number"
                step="0.01"
                placeholder="Digite o valor"
              />
            </div>
          </td>
        </tr>

        <tr>
          <td>
            <div className="mb-3">
              <label className="form-label">Descrição Entrada</label>
              <input
                value={ILEpt2Form05}
                onChange={(e) => setILEpt2Form05(e.target.value)}
                className="form-control"
                type="text"
                placeholder="Digite a descrição"
              />
            </div>
          </td>
          <td>
            <div className="mb-3">
              <label className="form-label" htmlFor="anexos">
                Anexos
              </label>
              <input
                id="anexos"
                type="file"
                multiple
                onChange={handleFileChange} // Atualiza a lista de anexos com os novos arquivos
                className="form-control"
              />
            </div>
          </td>
        </tr>

        <tr>
          <td>
              
            {/* Exibição condicional dos anexos */}
            {dataAnexos.length > 0 && (
              <div className="mb-3">
                <label className="form-label">Anexos Selecionados</label>
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Nome</th>
                      <th scope="col">Visualizar</th>
                      <th scope="col">Excluir</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataAnexos.map((anexo, index) => (
                      <tr key={index}>
                        <td>{anexo.name}</td>
                        <td>
                          <button
                            onClick={(event) => { openImages(event, anexo.name)} }
                            className="btn btn-primary btn-sm"
                            disabled={anexo.isPosibleEdit}
                          >
                            Visualizar
                          </button>
                        </td>
                        <td>
                          <button
                            onClick={() => deleteDataAnexos(anexo)}
                            className="btn btn-danger btn-sm"
                          >
                            Excluir
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </td>
        </tr>
      </table>
    );
  };

  const [searchbar, setSearchbar] = useState("");
  
  const handleSearch = async () => {
    try {
      let response;

      // Verificar se o campo de pesquisa está vazio após remover espaços
      if (searchbar.trim() === "") {
        // Se vazio, buscar todas as saídas
        response = await axios.get(
          `https://financeiro.api.protmar.com.br/${dataEmpresa}/getallentradas`
        );
      } else {
        // Caso contrário, realizar a busca com o valor do campo
        response = await axios.get(
          `https://financeiro.api.protmar.com.br/${dataEmpresa}/barrapesquisaentradas/${searchbar}`
        );
      }

      // Atualizar o estado com os dados recebidos
      setEntradas(response.data);
    } catch (error) {
      console.error("Erro ao realizar a busca:", error);
    }
  };


  const [entradasFormatada, setEntradasFormatada] = useState<any[][]>([]);
  const separadorLista = (dados: any[]) => {
    const lista2: any[][] = [];
    let lista1: any[] = [];

    for (let i = 0; i < dados.length; i++) {
      lista1.push(dados[i]);

      if (lista1.length === 10 || i === dados.length - 1) {
        lista2.push(lista1);
        lista1 = [];
      }
    }

    setEntradasFormatada(lista2); // Atualiza a estrutura de páginas
  };

  useEffect(() => {
    separadorLista(entradas);
  }, [entradas]);

  const [paginaSelecionada, setPaginaSelecionada] = useState(0);

  console.log(listaAnexos);
  return (
    <main id="ILEPt2Main">
      <ToastContainer />
      <div id="ILEDMainContainerInputDate">
        <div>
          <input
            type="date"
            value={dataPesquisaGeral}
            onChange={(e) => setDataPesquisaGeral(e.target.value)}
          />
          <button
            onClick={() => getAllComponentByData(dataPesquisaGeral)}
            className="btn btn-primary me-2"
          >
            Buscar
          </button>
          <button onClick={renderTabela} className="btn btn-primary me-2">
            Todas as Datas
          </button>
        </div>
      </div>

      {renderTabelaAddData()}
      <button style={{marginLeft: "-93%"}} onClick={saveData} className="btn btn-primary">Salvar</button>

      <div
        className="input-group mb-3"
        style={{
          maxWidth: "400px",
          width: "100vw",
          marginTop: "15px",
          marginLeft: "63%",
        }}
      >
        <input
          onChange={(e) => setSearchbar(e.target.value)}
          style={{ margin: "0" }}
          type="text"
          className="form-control"
          placeholder="Digite sua pesquisa"
          aria-label="Recipient's username"
          aria-describedby="basic-addon2"
        />
        <span
          onClick={() => {
            handleSearch();
          }}
          style={{ margin: "0", cursor: "pointer" }}
          className="input-group-text"
          id="basic-addon2"
        >
          Buscar
        </span>
      </div>

      <table className="table table-striped mt-3">
        <table
          style={{ width: "100%", position: "relative" }}
          className="table"
        >
          <thead>
            <td style={{ position: "absolute", top: "-15px" }}>Data</td>
            <td style={{ position: "absolute", top: "-15px", left: "33%" }}>
              Fonte de Entrada
            </td>
            <td style={{ position: "absolute", top: "-15px", left: "64%" }}>
              Valor de Entrada
            </td>
          </thead>
        </table>

        {entradasFormatada.length > 0 &&
        paginaSelecionada < entradasFormatada.length &&
        Array.isArray(entradasFormatada[paginaSelecionada]) ? (
          entradasFormatada[paginaSelecionada].map((entrada) => (
            <Accordion
              flush
              style={{ padding: "0" }}
              key={entrada.id}
              onClick={() => {
                setEntradaSelecionada(entrada);
              }}
            >
              <Accordion.Item eventKey="0" style={{ padding: "0" }}>
                <Accordion.Header style={{ padding: "0" }}>
                  <table
                    className="table table-bordered"
                    style={{ marginBottom: "0", marginRight: "20px" }}
                  >
                    <tbody>
                      <tr>
                        <td style={{ width: "33%" }}>
                          {new Date(entrada.dataentrada).toLocaleDateString(
                            "pt-BR"
                          )}
                        </td>
                        <td style={{ width: "33%" }}>{entrada.fonteentrada}</td>
                        <td style={{ width: "33%" }}>
                          R${" "}
                          {entrada.valorentrada
                            ? parseFloat(entrada.valorentrada).toLocaleString(
                                "pt-BR",
                                { style: "currency", currency: "BRL" }
                              )
                            : "0,00"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Accordion.Header>
                <Accordion.Body
                  style={{ padding: "10", boxShadow: "0 0 10px 1px #d9d9d9" }}
                >
                  {renderTabelaAddData()}
                  <button style={{ marginLeft:"10px" }} onClick={() => {
                    saveDataById(entrada.id);
                  }} className="btn btn-primary">
                    Atualizar
                  </button>

                  <button style={{ marginLeft:"10px" }} onClick={() => {
                    deleteData(entrada.id);
                    renderTabela();
                  }} className="btn btn-danger">
                    Excluir
                  </button>

                  <a className="btn btn-primary" style={{ marginLeft:"10px" }} onClick={handleExibirAnexosClick}>
                    Exibir Anexos
                  </a>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          ))
        ) : (
          <tr>
            <td colSpan={3} className="text-center">
              Nenhuma saída encontrada
            </td>
          </tr>
        )}
      </table>

      <nav aria-label="Page navigation example">
        <ul className="pagination">
          <li
            className={`page-item ${paginaSelecionada === 0 ? "disabled" : ""}`}
          >
            <a
              className="page-link"
              href="#"
              onClick={() =>
                paginaSelecionada > 0 &&
                setPaginaSelecionada(paginaSelecionada - 1)
              }
              aria-label="Previous"
            >
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>
          {paginaSelecionada - 1 >= 0 && (
            <li className="page-item">
              <a
                className="page-link"
                href="#"
                onClick={() => setPaginaSelecionada(paginaSelecionada - 1)}
              >
                {paginaSelecionada}
              </a>
            </li>
          )}
          <li className="page-item active">
            <span className="page-link">{paginaSelecionada + 1}</span>
          </li>
          {paginaSelecionada + 1 < entradasFormatada.length && (
            <li className="page-item">
              <a
                className="page-link"
                href="#"
                onClick={() => setPaginaSelecionada(paginaSelecionada + 1)}
              >
                {paginaSelecionada + 2}
              </a>
            </li>
          )}
          <li
            className={`page-item ${
              paginaSelecionada >= entradasFormatada.length - 1 ? "disabled" : ""
            }`}
          >
            <a
              className="page-link"
              href="#"
              onClick={() =>
                paginaSelecionada < entradasFormatada.length - 1 &&
                setPaginaSelecionada(paginaSelecionada + 1)
              }
              aria-label="Next"
            >
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
        </ul>
      </nav>
    </main>
  );
};

export { InfoLateralEntradasPt2 };
